var BaseViews = require('../../base');
var Swiper = require('swiper');
require('!style-loader!css-loader!swiper/css/swiper.css');
require('./photo-swiper/photo-swiper.scss');

var PhotoSwiper = BaseViews.LayoutView.extend({
  className: 'fmcy-photo-swiper',
  template: require('./photo-swiper/photo-swiper.html'),
  initialize: function(options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              theme: 'light',
              collection: null
          }
      );

      var SlideCollection = Backbone.Collection.extend({
        comparator: function (a) {
          if (a.get('is_primary') === '1') {
              return -1;
          } else {
              return 1;
          }
        }
      });

      this.slides = new SlideCollection(this.options.collection.toJSON());
      this.slides.each(function (model) {
        if (model.get('is_primary') === '1') {
          self._currentSlideModel = model;
        }
      });
  },
  ui: {
    swiperContainer: '.swiper-container',
    swiperPagination: '.swiper-pagination',
    swiperPrev: '.swiper-button-prev',
    swiperNext: '.swiper-button-next'
  },
  getCurrentSlideModel: function () {
    return this._currentSlideModel;
  },
  onRender: function() {
    var self = this;
    $(document).ready(function () {
      self.swiper = new Swiper (self.ui.swiperContainer, {
        direction: 'horizontal',
        loop: true,
        pagination: {
          el: self.ui.swiperPagination,
          clickable: true
        }
      });
      self.swiper.on('click',function(swiper,event){
        self.swiper.slideNext();
      });

      self.swiper.on('slideChange', function(swiper,event) {
        self._currentSlideModel = self.slides.at(self.swiper.realIndex);
        self.trigger('photo:swiper:slide:change', self._currentSlideModel);
      });

      function returnElement(model) {
        var url = model.get('medium_url');
        return '<div class="swiper-slide" id="' + model.get('id') + '"><div class="fmcy-menu-item-row fmcy-menu-item-thumb-image" style="background-image: url(' + url + ')"></div></div>';
      }
      var index = 0;
      self.slides.each(function (model) {
          self.swiper.addSlide(index, returnElement(model));
          index+=1;
      });
    });

    BaseViews.LayoutView.prototype.onRender.call(self);
  }
});

module.exports = PhotoSwiper;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-item-expanded/photo-swiper.js
 **/